export default __webpack_public_path__ + "static/media/Chakravarthy Jewellers logo.d8562624.jpg";